(function () {
'use strict';

(function(rum) {
    rum.logEventString = function (name, value, params) {
        return rum._logEvent('string', name, value, params);
    };

    rum.logEventFloat = function (name, value, params) {
        return rum._logEvent('float', name, value, params);
    };

    rum.logEventInteger = function (name, value, params) {
        return rum._logEvent('integer', name, value, params);
    };

    rum._logEvent = function(type, name, value, params) {
        params = params || {};
        var settings = rum._errorSettings;
        var additional = rum._buildAdditional(settings.additional, params.additional);
        var experiments = rum._buildExperiments(settings.experiments);
        var vars = {
            // окружение
            '-env': settings.env,

            // принадлежность к сервису
            '-project': settings.project,
            '-service': params.service || settings.service,
            '-page': params.page || settings.page,

            // платформа
            '-platform': settings.platform,

            // эксперименты
            '-experiments': experiments,

            // версия статики
            '-version': settings.version,

            // id пользователя
            '-yandexuid': settings.yandexuid,

            // залогинен ли пользователь
            '-loggedin': settings.loggedin,

            '-referrer': rum._getReferrer(settings),

            // хэш с дополнительными параметрами
            '-additional': additional,

            // клиентское время ошибки
            '-ts': +new Date(),

            // тип значения события
            '-type': type,

            // имя события
            '-name': name,

            // значение
            '-value': value,
        };

        return rum.send(null, '690.32', rum._createVarsString(vars), null, null, null, ['table=rum_events']);
    };
})(Ya.Rum);

}());
